module.exports = __webpack_public_path__ + "img/wgmi-coin.a26efaa5.svg";